import {useTranslation} from "react-i18next";
import { Link } from "react-router";
import telIcon from 'assets/images/foot_icon_tel.png';

export default function Footer(props){
  const {t} = useTranslation();
  
  return (
    <footer className={`${props.className} lg:px-0 bg-[rgba(0,0,0,0.9)] lg:py-16 flex justify-center`}>
      <div className="px-mobile lg:px-0 lg:w-[1200px] flex flex-col lg:flex-row lg:justify-center">
      <div className="flex flex-col justify-center py-6 text-white lg:py-10 lg:w-96">
        <p className="mb-2 text-2xl font-semibold lg:mb-4 lg:text-3xl">SJ Energy</p>
        <p className="text-2xl lg:text-3xl">주식회사 승진에너지</p>
      </div>
      <div className="flex flex-col justify-center w-full text-white lg:items-end">
        <div className="mb-2 lg:mb-4">
          <p className="h-6 text-xl font-light lg:font-normal lg:text-3xl" >
            <img src={telIcon} className='inline h-6 mr-3' alt='tel icon'/>
            {t('footer.title-phone')} {t('footer.phone')}</p>
        </div>
        <div>
          <p className="text-[10px] lg:text-sm font-light lg:font-normal">{t('footer.address')}</p>
        </div>
        <div className="flex flex-col lg:items-end lg:flex-row">
          <p className="lg:font-normal font-light text-[10px] lg:text-sm lg:mr-4">{t('footer.title-business-number')}. {t('footer.business-number')}</p>
          <div>
            <p className="lg:font-normal font-light text-[10px] lg:text-sm ">{t('footer.fax')} <span className="mx-2"/> {t('footer.email')}</p>
          </div>
        </div>
        <div>
          <p className="mt-2 text-gray-500 text-[10px] lg:text-end lg:mt-4 lg:text-sm font-extralight">Copyright SUENGJIN Energy Industry Co., Ltd. All rights reserved.</p>
          <Link to="/signin" className="text-sm text-gray-800 hover:text-gray-300">로그인</Link>
        </div>
      </div>
      </div>
    </footer>
  );
}